var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlipOutYRight = exports.FlipOutYLeft = exports.FlipOutXUp = exports.FlipOutXDown = exports.FlipOutEasyY = exports.FlipOutEasyX = exports.FlipInYRight = exports.FlipInYLeft = exports.FlipInXUp = exports.FlipInXDown = exports.FlipInEasyY = exports.FlipInEasyX = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_4429292551422_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'90deg'},{translateY:-targetValues.targetHeight}],...initialValues},animations:{transform:[{perspective:500},{rotateX:delayFunction(delay,animation('0deg',config))},{translateY:delayFunction(delay,animation(0,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","translateY","targetHeight","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AA6BY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,OAAQ,CAAC,CACpB,CAAEC,UAAU,CAAE,CAACX,YAAY,CAACY,YAAa,CAAC,CAC3C,CACD,GAAGX,aACL,CAAC,CACDY,UAAU,CAAE,CACVL,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CAAEM,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInXUp = exports.FlipInXUp = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(FlipInXUp, _ComplexAnimationBuil);
    var _super = _createSuper(FlipInXUp);
    function FlipInXUp() {
        var _this;
        (0, _classCallCheck2.default)(this, FlipInXUp);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "90deg"
                                },
                                {
                                    translateY: -targetValues.targetHeight
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_4429292551422_init_data;
                anonymous.__workletHash = 4429292551422;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(FlipInXUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInXUp();
            }
        }
    ]);
    return FlipInXUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_1181244280724_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'-90deg'},{translateX:-targetValues.targetWidth}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","translateX","targetWidth","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAsEY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,QAAS,CAAC,CACrB,CAAEC,UAAU,CAAE,CAACX,YAAY,CAACY,WAAY,CAAC,CAC1C,CACD,GAAGX,aACL,CAAC,CACDY,UAAU,CAAE,CACVL,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CAAEM,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInYLeft = exports.FlipInYLeft = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(FlipInYLeft, _ComplexAnimationBuil2);
    var _super2 = _createSuper(FlipInYLeft);
    function FlipInYLeft() {
        var _this2;
        (0, _classCallCheck2.default)(this, FlipInYLeft);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "-90deg"
                                },
                                {
                                    translateX: -targetValues.targetWidth
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_1181244280724_init_data;
                anonymous.__workletHash = 1181244280724;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(FlipInYLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInYLeft();
            }
        }
    ]);
    return FlipInYLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_15295471326176_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'-90deg'},{translateY:targetValues.targetHeight}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateX:delayFunction(delay,animation('0deg',config))},{translateY:delayFunction(delay,animation(0,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","translateY","targetHeight","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AA+GY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,QAAS,CAAC,CACrB,CAAEC,UAAU,CAAEX,YAAY,CAACY,YAAa,CAAC,CAC1C,CACD,GAAGX,aACL,CAAC,CACDY,UAAU,CAAE,CACVL,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CAAEM,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInXDown = exports.FlipInXDown = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(FlipInXDown, _ComplexAnimationBuil3);
    var _super3 = _createSuper(FlipInXDown);
    function FlipInXDown() {
        var _this3;
        (0, _classCallCheck2.default)(this, FlipInXDown);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var delay = _this3.getDelay();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "-90deg"
                                },
                                {
                                    translateY: targetValues.targetHeight
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateX: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_15295471326176_init_data;
                anonymous.__workletHash = 15295471326176;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(FlipInXDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInXDown();
            }
        }
    ]);
    return FlipInXDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_14913999216628_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'90deg'},{translateX:targetValues.targetWidth}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","translateX","targetWidth","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAwJY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,OAAQ,CAAC,CACpB,CAAEC,UAAU,CAAEX,YAAY,CAACY,WAAY,CAAC,CACzC,CACD,GAAGX,aACL,CAAC,CACDY,UAAU,CAAE,CACVL,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CAAEM,UAAU,CAAET,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInYRight = exports.FlipInYRight = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(FlipInYRight, _ComplexAnimationBuil4);
    var _super4 = _createSuper(FlipInYRight);
    function FlipInYRight() {
        var _this4;
        (0, _classCallCheck2.default)(this, FlipInYRight);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var delay = _this4.getDelay();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "90deg"
                                },
                                {
                                    translateX: targetValues.targetWidth
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_14913999216628_init_data;
                anonymous.__workletHash = 14913999216628;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(FlipInYRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInYRight();
            }
        }
    ]);
    return FlipInYRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_12941441359011_init_data = {
    code: "function anonymous(){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'90deg'}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateX:delayFunction(delay,animation('0deg',config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAiMW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CAAC,CAAEC,WAAW,CAAE,GAAI,CAAC,CAAE,CAAEC,OAAO,CAAE,OAAQ,CAAC,CAAC,CACvD,GAAGT,aACL,CAAC,CACDU,UAAU,CAAE,CACVH,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEhE,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInEasyX = exports.FlipInEasyX = function(_ComplexAnimationBuil5) {
    (0, _inherits2.default)(FlipInEasyX, _ComplexAnimationBuil5);
    var _super5 = _createSuper(FlipInEasyX);
    function FlipInEasyX() {
        var _this5;
        (0, _classCallCheck2.default)(this, FlipInEasyX);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
            args[_key5] = arguments[_key5];
        }
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        _this5.build = function() {
            var delayFunction = _this5.getDelayFunction();
            var _this5$getAnimationAn = _this5.getAnimationAndConfig(), _this5$getAnimationAn2 = (0, _slicedToArray2.default)(_this5$getAnimationAn, 2), animation = _this5$getAnimationAn2[0], config = _this5$getAnimationAn2[1];
            var delay = _this5.getDelay();
            var callback = _this5.callbackV;
            var initialValues = _this5.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "90deg"
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateX: delayFunction(delay, animation("0deg", config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_12941441359011_init_data;
                anonymous.__workletHash = 12941441359011;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this5;
    }
    (0, _createClass2.default)(FlipInEasyX, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInEasyX();
            }
        }
    ]);
    return FlipInEasyX;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_5576183094083_init_data = {
    code: "function anonymous(){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'90deg'}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('0deg',config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAqOW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CAAC,CAAEC,WAAW,CAAE,GAAI,CAAC,CAAE,CAAEC,OAAO,CAAE,OAAQ,CAAC,CAAC,CACvD,GAAGT,aACL,CAAC,CACDU,UAAU,CAAE,CACVH,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEhE,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipInEasyY = exports.FlipInEasyY = function(_ComplexAnimationBuil6) {
    (0, _inherits2.default)(FlipInEasyY, _ComplexAnimationBuil6);
    var _super6 = _createSuper(FlipInEasyY);
    function FlipInEasyY() {
        var _this6;
        (0, _classCallCheck2.default)(this, FlipInEasyY);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
            args[_key6] = arguments[_key6];
        }
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        _this6.build = function() {
            var delayFunction = _this6.getDelayFunction();
            var _this6$getAnimationAn = _this6.getAnimationAndConfig(), _this6$getAnimationAn2 = (0, _slicedToArray2.default)(_this6$getAnimationAn, 2), animation = _this6$getAnimationAn2[0], config = _this6$getAnimationAn2[1];
            var delay = _this6.getDelay();
            var callback = _this6.callbackV;
            var initialValues = _this6.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "90deg"
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("0deg", config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_5576183094083_init_data;
                anonymous.__workletHash = 5576183094083;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this6;
    }
    (0, _createClass2.default)(FlipInEasyY, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipInEasyY();
            }
        }
    ]);
    return FlipInEasyY;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2254065455864_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'0deg'},{translateY:0}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateX:delayFunction(delay,animation('90deg',config))},{translateY:delayFunction(delay,animation(-targetValues.currentHeight,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","translateY","animations","currentHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAyQY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,MAAO,CAAC,CACnB,CAAEC,UAAU,CAAE,CAAE,CAAC,CAClB,CACD,GAAGV,aACL,CAAC,CACDW,UAAU,CAAE,CACVJ,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CACEM,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAAC,CAACJ,YAAY,CAACa,aAAa,CAAER,MAAM,CAC/C,CACF,CAAC,CAEL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutXUp = exports.FlipOutXUp = function(_ComplexAnimationBuil7) {
    (0, _inherits2.default)(FlipOutXUp, _ComplexAnimationBuil7);
    var _super7 = _createSuper(FlipOutXUp);
    function FlipOutXUp() {
        var _this7;
        (0, _classCallCheck2.default)(this, FlipOutXUp);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++){
            args[_key7] = arguments[_key7];
        }
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        _this7.build = function() {
            var delayFunction = _this7.getDelayFunction();
            var _this7$getAnimationAn = _this7.getAnimationAndConfig(), _this7$getAnimationAn2 = (0, _slicedToArray2.default)(_this7$getAnimationAn, 2), animation = _this7$getAnimationAn2[0], config = _this7$getAnimationAn2[1];
            var delay = _this7.getDelay();
            var callback = _this7.callbackV;
            var initialValues = _this7.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "0deg"
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateX: delayFunction(delay, animation("90deg", config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(-targetValues.currentHeight, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_2254065455864_init_data;
                anonymous.__workletHash = 2254065455864;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this7;
    }
    (0, _createClass2.default)(FlipOutXUp, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutXUp();
            }
        }
    ]);
    return FlipOutXUp;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2264532083244_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'0deg'},{translateX:0}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('-90deg',config))},{translateX:delayFunction(delay,animation(-targetValues.currentWidth,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","translateX","animations","currentWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAuTY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,MAAO,CAAC,CACnB,CAAEC,UAAU,CAAE,CAAE,CAAC,CAClB,CACD,GAAGV,aACL,CAAC,CACDW,UAAU,CAAE,CACVJ,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC9D,CACEM,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAAC,CAACJ,YAAY,CAACa,YAAY,CAAER,MAAM,CAC9C,CACF,CAAC,CAEL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutYLeft = exports.FlipOutYLeft = function(_ComplexAnimationBuil8) {
    (0, _inherits2.default)(FlipOutYLeft, _ComplexAnimationBuil8);
    var _super8 = _createSuper(FlipOutYLeft);
    function FlipOutYLeft() {
        var _this8;
        (0, _classCallCheck2.default)(this, FlipOutYLeft);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++){
            args[_key8] = arguments[_key8];
        }
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        _this8.build = function() {
            var delayFunction = _this8.getDelayFunction();
            var _this8$getAnimationAn = _this8.getAnimationAndConfig(), _this8$getAnimationAn2 = (0, _slicedToArray2.default)(_this8$getAnimationAn, 2), animation = _this8$getAnimationAn2[0], config = _this8$getAnimationAn2[1];
            var delay = _this8.getDelay();
            var callback = _this8.callbackV;
            var initialValues = _this8.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "0deg"
                                },
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("-90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(-targetValues.currentWidth, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_2264532083244_init_data;
                anonymous.__workletHash = 2264532083244;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this8;
    }
    (0, _createClass2.default)(FlipOutYLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutYLeft();
            }
        }
    ]);
    return FlipOutYLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_13151610102584_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'0deg'},{translateY:0}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateX:delayFunction(delay,animation('-90deg',config))},{translateY:delayFunction(delay,animation(targetValues.currentHeight,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","translateY","animations","currentHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAqWY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,MAAO,CAAC,CACnB,CAAEC,UAAU,CAAE,CAAE,CAAC,CAClB,CACD,GAAGV,aACL,CAAC,CACDW,UAAU,CAAE,CACVJ,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC9D,CACEM,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAACJ,YAAY,CAACa,aAAa,CAAER,MAAM,CAC9C,CACF,CAAC,CAEL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutXDown = exports.FlipOutXDown = function(_ComplexAnimationBuil9) {
    (0, _inherits2.default)(FlipOutXDown, _ComplexAnimationBuil9);
    var _super9 = _createSuper(FlipOutXDown);
    function FlipOutXDown() {
        var _this9;
        (0, _classCallCheck2.default)(this, FlipOutXDown);
        for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++){
            args[_key9] = arguments[_key9];
        }
        _this9 = _super9.call.apply(_super9, [
            this
        ].concat(args));
        _this9.build = function() {
            var delayFunction = _this9.getDelayFunction();
            var _this9$getAnimationAn = _this9.getAnimationAndConfig(), _this9$getAnimationAn2 = (0, _slicedToArray2.default)(_this9$getAnimationAn, 2), animation = _this9$getAnimationAn2[0], config = _this9$getAnimationAn2[1];
            var delay = _this9.getDelay();
            var callback = _this9.callbackV;
            var initialValues = _this9.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "0deg"
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateX: delayFunction(delay, animation("-90deg", config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(targetValues.currentHeight, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_13151610102584_init_data;
                anonymous.__workletHash = 13151610102584;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this9;
    }
    (0, _createClass2.default)(FlipOutXDown, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutXDown();
            }
        }
    ]);
    return FlipOutXDown;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2479377105132_init_data = {
    code: "function anonymous(targetValues){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'0deg'},{translateX:0}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('90deg',config))},{translateX:delayFunction(delay,animation(targetValues.currentWidth,config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","targetValues","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","translateX","animations","currentWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAmZY,SAAAA,UAAAC,YAAiB,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEvB,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CACT,CAAEC,WAAW,CAAE,GAAI,CAAC,CACpB,CAAEC,OAAO,CAAE,MAAO,CAAC,CACnB,CAAEC,UAAU,CAAE,CAAE,CAAC,CAClB,CACD,GAAGV,aACL,CAAC,CACDW,UAAU,CAAE,CACVJ,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CACEM,UAAU,CAAET,aAAa,CACvBC,KAAK,CACLC,SAAS,CAACJ,YAAY,CAACa,YAAY,CAAER,MAAM,CAC7C,CACF,CAAC,CAEL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutYRight = exports.FlipOutYRight = function(_ComplexAnimationBuil10) {
    (0, _inherits2.default)(FlipOutYRight, _ComplexAnimationBuil10);
    var _super10 = _createSuper(FlipOutYRight);
    function FlipOutYRight() {
        var _this10;
        (0, _classCallCheck2.default)(this, FlipOutYRight);
        for(var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++){
            args[_key10] = arguments[_key10];
        }
        _this10 = _super10.call.apply(_super10, [
            this
        ].concat(args));
        _this10.build = function() {
            var delayFunction = _this10.getDelayFunction();
            var _this10$getAnimationA = _this10.getAnimationAndConfig(), _this10$getAnimationA2 = (0, _slicedToArray2.default)(_this10$getAnimationA, 2), animation = _this10$getAnimationA2[0], config = _this10$getAnimationA2[1];
            var delay = _this10.getDelay();
            var callback = _this10.callbackV;
            var initialValues = _this10.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(targetValues) {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "0deg"
                                },
                                {
                                    translateX: 0
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(targetValues.currentWidth, config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_2479377105132_init_data;
                anonymous.__workletHash = 2479377105132;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this10;
    }
    (0, _createClass2.default)(FlipOutYRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutYRight();
            }
        }
    ]);
    return FlipOutYRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_10427242009219_init_data = {
    code: "function anonymous(){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateX:'0deg'}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateX:delayFunction(delay,animation('90deg',config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateX","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAicW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CAAC,CAAEC,WAAW,CAAE,GAAI,CAAC,CAAE,CAAEC,OAAO,CAAE,MAAO,CAAC,CAAC,CACtD,GAAGT,aACL,CAAC,CACDU,UAAU,CAAE,CACVH,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEjE,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutEasyX = exports.FlipOutEasyX = function(_ComplexAnimationBuil11) {
    (0, _inherits2.default)(FlipOutEasyX, _ComplexAnimationBuil11);
    var _super11 = _createSuper(FlipOutEasyX);
    function FlipOutEasyX() {
        var _this11;
        (0, _classCallCheck2.default)(this, FlipOutEasyX);
        for(var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++){
            args[_key11] = arguments[_key11];
        }
        _this11 = _super11.call.apply(_super11, [
            this
        ].concat(args));
        _this11.build = function() {
            var delayFunction = _this11.getDelayFunction();
            var _this11$getAnimationA = _this11.getAnimationAndConfig(), _this11$getAnimationA2 = (0, _slicedToArray2.default)(_this11$getAnimationA, 2), animation = _this11$getAnimationA2[0], config = _this11$getAnimationA2[1];
            var delay = _this11.getDelay();
            var callback = _this11.callbackV;
            var initialValues = _this11.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateX: "0deg"
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateX: delayFunction(delay, animation("90deg", config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_10427242009219_init_data;
                anonymous.__workletHash = 10427242009219;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this11;
    }
    (0, _createClass2.default)(FlipOutEasyX, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutEasyX();
            }
        }
    ]);
    return FlipOutEasyX;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_6721664529475_init_data = {
    code: "function anonymous(){const{initialValues,delayFunction,delay,animation,config,callback}=this.__closure;return{initialValues:{transform:[{perspective:500},{rotateY:'0deg'}],...initialValues},animations:{transform:[{perspective:delayFunction(delay,animation(500,config))},{rotateY:delayFunction(delay,animation('90deg',config))}]},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts",
    sourceMap: '{"version":3,"names":["anonymous","initialValues","delayFunction","delay","animation","config","callback","__closure","transform","perspective","rotateY","animations"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Flip.ts"],"mappings":"AAqeW,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEX,MAAO,CACLN,aAAa,CAAE,CACbO,SAAS,CAAE,CAAC,CAAEC,WAAW,CAAE,GAAI,CAAC,CAAE,CAAEC,OAAO,CAAE,MAAO,CAAC,CAAC,CACtD,GAAGT,aACL,CAAC,CACDU,UAAU,CAAE,CACVH,SAAS,CAAE,CACT,CAAEC,WAAW,CAAEP,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,GAAG,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CAAEK,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAEjE,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var FlipOutEasyY = exports.FlipOutEasyY = function(_ComplexAnimationBuil12) {
    (0, _inherits2.default)(FlipOutEasyY, _ComplexAnimationBuil12);
    var _super12 = _createSuper(FlipOutEasyY);
    function FlipOutEasyY() {
        var _this12;
        (0, _classCallCheck2.default)(this, FlipOutEasyY);
        for(var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++){
            args[_key12] = arguments[_key12];
        }
        _this12 = _super12.call.apply(_super12, [
            this
        ].concat(args));
        _this12.build = function() {
            var delayFunction = _this12.getDelayFunction();
            var _this12$getAnimationA = _this12.getAnimationAndConfig(), _this12$getAnimationA2 = (0, _slicedToArray2.default)(_this12$getAnimationA, 2), animation = _this12$getAnimationA2[0], config = _this12$getAnimationA2[1];
            var delay = _this12.getDelay();
            var callback = _this12.callbackV;
            var initialValues = _this12.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous() {
                    return {
                        initialValues: Object.assign({
                            transform: [
                                {
                                    perspective: 500
                                },
                                {
                                    rotateY: "0deg"
                                }
                            ]
                        }, initialValues),
                        animations: {
                            transform: [
                                {
                                    perspective: delayFunction(delay, animation(500, config))
                                },
                                {
                                    rotateY: delayFunction(delay, animation("90deg", config))
                                }
                            ]
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    initialValues: initialValues,
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_6721664529475_init_data;
                anonymous.__workletHash = 6721664529475;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this12;
    }
    (0, _createClass2.default)(FlipOutEasyY, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new FlipOutEasyY();
            }
        }
    ]);
    return FlipOutEasyY;
}(_animationBuilder.ComplexAnimationBuilder);
